import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmailHelper  {
    _originalTypeClassName = "zPMO.BO.EmailHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmailHelper.translate = translateService;
}
this.EmailHelperKey = null;
this._key = this.EmailHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _EmailHelperKey:any;
get EmailHelperKey(): any {
    return this._EmailHelperKey;
  }
set EmailHelperKey(value: any) {
    this._EmailHelperKey = value;
    this._key = value;
  }

static MaxEmailRetries(): any{return 5;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmailHelperKey == null || $this.EmailHelperKey == 0;
            }


}